module.exports = __webpack_public_path__ + "files/1b226149c7920e96e4c47faf0ff73d8c.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Main-Italic.ttf
// module id = 1185
// module chunks = 76